// extracted by mini-css-extract-plugin
export default {"flexbox-container":"Experience_flexbox-container__YxZe3"};